import type { Styles } from '@adornis/ass/style';
import { type Maybe, type ValueEvent } from '@adornis/base/utilTypes';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration';
import '@adornis/digitale-helden-shared/client/theme/d-dropdown-search-selection';
import { MarketingPage } from '@adornis/digitale-helden-shared/db/MarketingPage';
import { FormField } from '@adornis/formfield/form-field';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';

@customElement('marketing-page-picker')
export class MarketingPagePicker extends FormField<Maybe<string>> {
  override render() {
    return html`
      <d-dropdown-search-selection
        clearable
        placeholder="Seite auswählen um den Kontent zu kopieren"
        .search=${async search => {
          const selectionset: BaseQLSelectionSet<MarketingPage> = { _id: 1, _class: 1, path: 1, name: 1 };
          const query = search
            ? MarketingPage.getMarketingPagesBySearch(search)(selectionset)
            : MarketingPage.getAll()(selectionset);
          const results = await query;
          return results;
        }}
        .renderString=${(page: Maybe<MarketingPage>) => {
          return page?.name;
        }}
        @value-picked=${(e: ValueEvent<Maybe<MarketingPage>>) => {
          const value = e.detail.value?._id;
          this.value.next(value);
          this.dispatchEvent(new CustomEvent('value-picked', { detail: { value: this.value.value } }));
        }}
      ></d-dropdown-search-selection>
    `;
  }

  override styles() {
    return [
      ...super.styles(),
      {
        ':host': {},
      },
    ] as Styles[];
  }
}
